'use strict';

var _ = require('lodash');
var DiscontinuedRoutesRendererFactory = function DiscontinuedRoutesRendererFactory() {
  var discontinueRoutesRenderer = function discontinueRoutesRenderer(columnContext, row, columnfield, value, defaultValue) {
    return defaultValue.replace(/(-(\d+)-)/g, '-<span class="gridcell-discontinued-routes">$2</span>-');
  };
  return {
    discontinueRoutes: discontinueRoutesRenderer
  };
};
DiscontinuedRoutesRendererFactory.$inject = [];
module.exports = DiscontinuedRoutesRendererFactory;